// extracted by mini-css-extract-plugin
export var backgroundImage = "SupportHeroSection-module--backgroundImage--cff78";
export var content = "SupportHeroSection-module--content--b2712";
export var cta = "SupportHeroSection-module--cta--aea70";
export var info = "SupportHeroSection-module--info--b55b3";
export var nav = "SupportHeroSection-module--nav--adb57";
export var title = "SupportHeroSection-module--title--1fcf2";
export var wrapper = "SupportHeroSection-module--wrapper--3c2a4";